import Grid from "@material-ui/core/Grid"
import React, { memo } from "react"
import { RouteComponentProps, useLocation, withRouter } from "react-router-dom"
import NavigationLink from "../NavigationLink"
import Translation from "../Translation"
import { IconContainer, NavigationItemContainer, StyledDivider, StyledNavigationText } from "./style"

type TNavigationItem = {
  name: string
  to: string
  icon: JSX.Element
  index: number
} & RouteComponentProps

function NavigationItem({ name, to, icon: Icon, index }: TNavigationItem) {
  const { pathname } = useLocation()
  const isActive = to.split("/")[1] === pathname.split("/")[1]
  return (
    <NavigationLink data-cy={to} to={to}>
      {index === 0 && <StyledDivider />}
      <NavigationItemContainer isActive={isActive}>
        <Grid container={true} spacing={0}>
          {Icon && (
            <Grid item={true} xs={12}>
              <IconContainer>{Icon}</IconContainer>
            </Grid>
          )}
          <Grid item={true} xs={12}>
            <StyledNavigationText>
              <Translation label={name} />
            </StyledNavigationText>
          </Grid>
        </Grid>
      </NavigationItemContainer>
      <StyledDivider />
    </NavigationLink>
  )
}

export default withRouter(memo(NavigationItem))
